
<template>
    <div class="gallery-page" style="padding-top: 56px">
        <galleryComponent />
    </div>
</template>
  
<style lang="scss" scoped>
</style>